import { render, staticRenderFns } from "./PoliticaAmbiental.vue?vue&type=template&id=b3ed9216&scoped=true"
import script from "./PoliticaAmbiental.vue?vue&type=script&lang=js"
export * from "./PoliticaAmbiental.vue?vue&type=script&lang=js"
import style0 from "./PoliticaAmbiental.vue?vue&type=style&index=0&id=b3ed9216&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3ed9216",
  null
  
)

export default component.exports